<template>
    <div class="tm-item uk-card uk-card-small uk-card-default">

        <div class="uk-grid-divider uk-grid-small uk-child-width-1-1 uk-child-width-1-2@m"
             uk-grid>

            <div>

                <div class="tm-item-circuit-body uk-card-body">
                    <div class="uk-grid-collapse uk-flex-middle uk-flex-center"
                         uk-grid>

                        <div class="uk-width-1-1">
                            <div v-if="page.ShopFilterPropertyValues[3]" class="uk-text-center tm-circuit-text uk-margin-auto uk-text-bold-600 tm-circuit-value">
                                <div>P<sub>макс.</sub></div>
                                <div v-if="page.ShopFilterPropertyValues[3].length == 1">
                                    <div v-for="value in page.ShopFilterPropertyValues[3]" :key="value.id" class="tm-circuit-value-s">{{ value.value_varchar }}</div>
                                </div>
                                <div v-else style="height: 21px;"></div>
                            </div>
                        </div>

                        <div class="uk-text-center" style="width: 100%;position: relative;">

                            <div class="uk-width-xsmall" style="position: absolute;top: 39%;">
                                <div v-if="page.ShopFilterPropertyValues[4]" class="uk-text-center tm-circuit-text uk-text-bold-600 tm-circuit-value">
                                    <div>U<sub>вх.</sub></div>
                                    <div v-if="page.ShopFilterPropertyValues[4].length == 1">
                                        <div v-for="value in page.ShopFilterPropertyValues[4]" :key="value.id" class="tm-circuit-value-s">{{ value.value_varchar }}</div>
                                    </div>
                                    <div v-else style="height: 21px;"></div>
                                </div>
                            </div>

                            <img src="/resources/twpower/assets/images/transformer-circuit.svg"
                                 style="width: auto;height: 250px;" />

                             <div class="uk-width-xsmall tm-circuit-right-values-block">

                                 <div v-if="page.ShopFilterPropertyValues[7]" class="uk-text-center tm-circuit-text uk-text-bold-600 tm-circuit-right-value tm-margin-top-50">
                                     <div>U<sub>вых. ном</sub></div>
                                     <div v-if="page.ShopFilterPropertyValues[7].length == 1">
                                         <div v-for="value in page.ShopFilterPropertyValues[7]" :key="value.id" class="tm-circuit-text-small tm-circuit-value-s">{{ value.value_varchar }}</div>
                                     </div>
                                     <div v-else style="height: 21px;"></div>
                                 </div>

                                 <div v-if="page.ShopFilterPropertyValues[8]" class="uk-text-center tm-circuit-text uk-text-bold-600 tm-circuit-right-value">
                                     <div>I<sub>ном. нагр.</sub></div>
                                     <div v-if="page.ShopFilterPropertyValues[8].length == 1">
                                         <div v-for="value in page.ShopFilterPropertyValues[8]" :key="value.id" class="tm-circuit-text-small tm-circuit-value-s">{{ value.value_varchar }}</div>
                                     </div>
                                     <div v-else style="height: 21px;"></div>
                                 </div>

                             </div>
                        </div>

                        <div v-if="page.ShopFilterPropertyValues[key] && mainvalue.indexOf(parseInt(key)) < 0 && page.ShopFilterPropertyValues[key].length == 1"
                             v-for="(ShopFilterPropertyValue,key) in page.ShopFilterPropertyValues"
                             :key="ShopFilterPropertyValue.id"
                             class="uk-width-1-1">
                            <div class="uk-width-1-1">
                                <div v-for="value in page.ShopFilterPropertyValues[key]"
                                     :key="value.id"
                                     class="uk-text-left tm-circuit-value tm-circuit-text-small uk-margin-auto uk-text-bold-600">
                                    <div v-for="ShopFilterProperty in page.ShopFilterProperties"
                                         v-if="ShopFilterProperty.id == key"
                                         :key="ShopFilterProperty.id">
                                         {{ShopFilterProperty.name}}: <span class="tm-circuit-value-s">{{ value.value_varchar }}</span>
                                     </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div>

                <div class="tm-item-shop-body uk-card-body">

                    <div class="uk-h3 uk-text-center">Подбор по параметрам</div>

                    <div class="uk-grid-small uk-child-width-1-2"
                         uk-grid>


                        <property-select v-for="ShopFilterProperty in page.ShopFilterProperties"
                                         :key="ShopFilterProperty.id"
                                         :property="ShopFilterProperty"
                                         :property-values="page.ShopFilterPropertyValues[ShopFilterProperty.id]"
                                         :selected.sync="params.propertyValues[ShopFilterProperty.id]"
                                         @property-value-selected="filterChanged">

                        </property-select>
                        <div class="uk-width-1-1 uk-text-center">
                            <p class="uk-text-left">Товаров: {{ page.ShopItems.total_items }}</p>
                            <a :href="href" class="uk-button uk-button-primary tm-ft-button uk-margin-xsmall-top">
                                Показать
                            </a>
                        </div>
                        <div class="uk-width-1-1 uk-text-center uk-margin-xsmall-top">
                            <a v-if="Object.keys(params.propertyValues).length !== 0" @click="reset" class="uk-button uk-button-danger tm-ft-button uk-margin-xsmall-top">
                                Сбросить
                            </a>
                        </div>

                    </div>
                </div>

            </div>

        </div>

        <div v-show="loading" class="uk-overlay-default uk-position-cover">
            <div class="uk-position-center">
                <div uk-spinner="ratio: 3"></div>
            </div>
        </div>

    </div>
</template>

<script>
    import PropertySelect from "./PropertySelect";

    export default {
        name: "FindTransformers",
        components: {PropertySelect},
        props: {},
        created() {
            this.fetchShopItems();
        },
        data() {
            return {
                page: {
                    ShopItems: {},
                    ShopFilterProperties: {},
                    ShopFilterPropertyValues: {},
                },
                params: {
                    propertyValues: {},
                },
                mainvalue: [3,4,7,8],
                loading: true,
                href: ''
            }
        },
        methods: {
            filterChanged(property, propertyValues) {
                this.params.propertyValues = {...this.params.propertyValues, ...{[property.id]: [propertyValues]}};

                this.fetchShopItems();
            },
            reset(){
                this.params.propertyValues = {};
                this.$emit('reset-properties-values');
                this.fetchShopItems();

            },
            fetchShopItems() {
                this.loading = true;
                this.$http.get('/transformers', {
                    params: this.params
                }).then(response => {

                    this.page = response.body.data;

                    this.loading = false;

                    this.href = response.url

                }, response => {
                    this.loading = false;
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// FindTransformers.vue?4311896b